import axios from 'axios'

import request from '../utils/request'

// 获取原始Avatar数据
export function getAvatarList() {
  return request({
    url: 'api/babe/figure_config',
    method: 'get'
  })
}

export function getAvatarListMock() {
  return {
    body: [
      {
        id: 1,
        image: 'BABENFT/BABENFT_2_body.png',
        text: '1',
        icon: 'BABENFT/BABENFT_2_body.png'
      },
      {
        id: 2,
        image: 'BABENFT/BABENFT_2_body.png',
        text: '2',
        icon: 'BABENFT/BABENFT_2_body.png'
      },
      {
        id: 3,
        image: 'BABENFT/BABENFT_2_body.png',
        text: '3',
        icon: 'BABENFT/BABENFT_2_body.png'
      }
    ],
    nation: [
      {
        id: 1,
        'flag-image': 'BABENFT/BABENFT_1_nation.png',
        'uniform-image': 'BABENFT/BABENFT_3_uniform.png',
        text: '1',
        icon: 'BABENFT/BABENFT_1_nation.png'
      },
      {
        id: 2,
        'flag-image': 'BABENFT/BABENFT_1_nation.png',
        'uniform-image': 'BABENFT/BABENFT_3_uniform.png',
        text: '2',
        icon: 'BABENFT/BABENFT_1_nation.png'
      },
      {
        id: 2,
        'flag-image': 'BABENFT/BABENFT_1_nation.png',
        'uniform-image': 'BABENFT/BABENFT_3_uniform.png',
        text: '2',
        icon: 'BABENFT/BABENFT_1_nation.png'
      }
    ],
    pants: [
      {
        id: 1,
        image: 'BABENFT/BABENFT_4_pants.png',
        text: '1',
        icon: 'BABENFT/BABENFT_4_pants.png'
      },
      {
        id: 2,
        image: 'BABENFT/BABENFT_4_pants.png',
        text: '2',
        icon: 'BABENFT/BABENFT_4_pants.png'
      },
      {
        id: 3,
        image: 'BABENFT/BABENFT_4_pants.png',
        text: '3',
        icon: 'BABENFT/BABENFT_4_pants.png'
      }
    ],
    hair: [
      {
        id: 1,
        image: 'BABENFT/BABENFT_5_hair.png',
        text: '1',
        icon: 'BABENFT/BABENFT_5_hair.png'
      },
      {
        id: 2,
        image: 'BABENFT/BABENFT_5_hair.png',
        text: '2',
        icon: 'BABENFT/BABENFT_5_hair.png'
      },
      {
        id: 3,
        image: 'BABENFT/BABENFT_5_hair.png',
        text: '3',
        icon: 'BABENFT/BABENFT_5_hair.png'
      }
    ],
    eyes: [
      {
        id: 1,
        image: 'BABENFT/BABENFT_6_eyes.png',
        text: '1',
        icon: 'BABENFT/BABENFT_6_eyes.png'
      },
      {
        id: 2,
        image: 'BABENFT/BABENFT_6_eyes.png',
        text: '2',
        icon: 'BABENFT/BABENFT_6_eyes.png'
      },
      {
        id: 3,
        image: 'BABENFT/BABENFT_6_eyes.png',
        text: '3',
        icon: 'BABENFT/BABENFT_6_eyes.png'
      }
    ],
    mouth: [
      {
        id: 1,
        image: 'BABENFT/BABENFT_7_mouth.png',
        text: '1',
        icon: 'BABENFT/BABENFT_7_mouth.png'
      },
      {
        id: 2,
        image: 'BABENFT/BABENFT_7_mouth.png',
        text: '2',
        icon: 'BABENFT/BABENFT_7_mouth.png'
      },
      {
        id: 3,
        image: 'BABENFT/BABENFT_7_mouth.png',
        text: '3',
        icon: 'BABENFT/BABENFT_7_mouth.png'
      }
    ],
    getImgPath: function (orgPath) {
      return require('@/assets/images/' + orgPath)
    }
  }
}

// 上传图片
export function uploadAvatar(data) {
  return request({
    url: 'api/babe/image/upload',
    method: 'post',
    data: data,
    headers: {
      Accept: 'application/json, text/plain, */*',
      'Content-Type': 'multipart/form-data'
    }
  })
}

// 提交User的Avatar
export function confirmAvatar(data) {
  return request({
    url: 'api/babe/nft/mint',
    method: 'post',
    data: data
  })
}

export function getUserAvatarList() {
  return request({
    url: 'api/home/figure_config',
    method: 'get'
  })
}

// 上传图片
export function uploadUserAvatar(data) {
  return request({
    url: 'api/home/image/upload',
    method: 'post',
    data: data,
    headers: {
      Accept: 'application/json, text/plain, */*',
      'Content-Type': 'multipart/form-data'
    }
  })
}

// 提交User的Avatar
export function confirmUserAvatar(data) {
  return request({
    url: 'api/home/nft/mint',
    method: 'post',
    data: data
  })
}

// 临时API，用来模拟支付回调的Webhook
export function chargeWebhook(userID, coin) {
  console.log(userID)
  return request({
    url: 'api/home/onramper/callback',
    method: 'post',
    data: {
      type: 'transaction_completed',
      payload: {
        txId: Math.random().toString(32).substring(2).toUpperCase(),
        gatewayIdentifier: 'Wyre',
        timestamp: 1624227875007,
        inCurrency: 'EUR',
        inAmount: 50,
        outCurrency: 'ETH',
        outAmount: coin,
        purchaseAmount: 31.75,
        partnerContext: {
          myTxId: 'TwQC716Q8D',
          myUserId: userID,
          lastTab: 'wallet-funds'
        }
      }
    }
  })
}



// WEBPACK FOOTER //
// ./src/api/avatar.js